/**
 * Tiny id generator for Coral-Placer entities (placements, aquascapes).
 * Prefers the crypto UUID when available, with a deterministic-enough
 * fallback for older runtimes.
 */
export function genId(prefix: string): string {
  const cryptoObj =
    typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  const rand =
    cryptoObj && typeof cryptoObj.randomUUID === 'function'
      ? cryptoObj.randomUUID()
      : `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
  return `${prefix}_${rand}`;
}
